import { SvgIcon, SvgIconProps } from '@/theme/index';

export function SmartSearchIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="-1 -1 30 30" {...props}>
      <rect
        width="28"
        height="28"
        rx="14"
        fill="url(#paint0_linear_35_32164)"
      />
      <rect
        width="28"
        height="28"
        rx="14"
        stroke="url(#paint1_linear_35_32164)"
      />
      <g clipPath="url(#clip0_35_32164)">
        <path
          d="M19.8333 11.5L20.8749 9.20831L23.1666 8.16665L20.8749 7.12498L19.8333 4.83331L18.7916 7.12498L16.4999 8.16665L18.7916 9.20831L19.8333 11.5ZM13.5833 11.9166L11.4999 7.33331L9.41658 11.9166L4.83325 14L9.41658 16.0833L11.4999 20.6666L13.5833 16.0833L18.1666 14L13.5833 11.9166ZM19.8333 16.5L18.7916 18.7916L16.4999 19.8333L18.7916 20.875L19.8333 23.1666L20.8749 20.875L23.1666 19.8333L20.8749 18.7916L19.8333 16.5Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_35_32164"
          x1="-3"
          y1="9.5"
          x2="28.5"
          y2="23"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B223E4" />
          <stop offset="1" stopColor="#2B07D2" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_35_32164"
          x1="1"
          y1="18.5"
          x2="27"
          y2="18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8E80CE" />
          <stop offset="0.48761" stopColor="#B223E4" />
          <stop offset="1" stopColor="#2B07D2" />
        </linearGradient>
        <clipPath id="clip0_35_32164">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
